const uRLs = {
    API_URL : process.env.REACT_APP_API_URL,
    IMAGE_URL : process.env.REACT_APP_IMAGE_PREFIX,
    BILL_PORTEL_URL : process.env.REACT_APP_BILL_PORTEL_URL,
    PUBLIC_PORTAL_URL:process.env.REACT_APP_PUBLIC_PORTAL_URL,
};

export default uRLs;
